import React from "react";
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
import openApi from "./openApi";

import Up from "./openApi/components/html/up";

const App = () => (
  <>
    <SwaggerUI spec={openApi} docExpansion="list" /> <Up />
  </>
);

export default App;
